module.exports = __webpack_public_path__ + "static/partner-kyocera-2d746ae22077a4faf71a24216ca70bfc.jpg";